/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import AssetService from "../../services/AssetService";
import { If } from "../../utils/Controls";
import { AntdPaging, AntdSelect, AntdTag } from "../../utils/Antd";
import util from "../../utils/util";
import Tabs, { PageHeading } from "./Tabs";
import AssetSubCat from './AssetSubCat';
import plus from "../assets/icons/plus.svg"
import edit from "../assets/icons/pen-to-square-solid.svg"
import xmark from "../assets/icons/circle-xmark-solid.svg"
import search from "../assets/icons/magnifying-glass-solid.svg"

import {
    Input,
    Button,
    message,
    Modal,
} from 'antd';
import {
    ExclamationCircleOutlined,
} from '@ant-design/icons';
const { confirm } = Modal;

export default function AssetCats() {
    const [result, setResult] = useState({ data: [], page: {} });
    const [subCat, setSubCat] = useState({ catId: '', catDtl: {}, drawerVisible: false })
    const sdataRef = useRef({ p: 1, ps: 25 });
    const formRef = useRef();

    const list = (p, ps) => {
        sdataRef.current.p = p || 1;
        sdataRef.current.ps = ps || sdataRef.current.ps;
        util.showLoader();
        AssetService.cats(sdataRef.current).then(({ data }) => {
            setResult(data.result);
        }).catch(e => {
            message.error(e.message);
        }).finally(() => {
            util.hideLoader();
        })
    }

    const deleteRecord = (id) => {
        message.destroy();
        confirm({
            title: 'Do you Want to delete this category?',
            icon: <ExclamationCircleOutlined />,
            content: '',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk() {
                util.showLoader();
                AssetService.deleteCat(id).then(({ data }) => {
                    message.success(data.message || 'Deleted');
                    list();
                }).catch(e => {
                    message.error(e.message);
                }).finally(() => {
                    util.hideLoader();
                })
            },
            onCancel() {
            },
        })
    }

    const openSubCatDrawer = ({ catId, catDtl }) => {
        setSubCat({ catId, catDtl, drawerVisible: true, forceCall: Math.random() });
    }

    useEffect(() => {
        list();

        return () => { message.destroy() }
    }, []);

    return (
        <div className="page-content">
            <div className="page-head uc d-flex">
                <div className="my-auto">
                    <PageHeading />
                </div>
                <div className="my-auto ml-auto"></div>
            </div>

            <div className="page-pad">
                <div className="tabbable-custom">
                    <Tabs active="asset-cats" />
                    <div className="tab-content">
                        <div className="tab-pane fade1 show active">
                            {result.data.length > 0 &&
                                <div className="text-secondary mb8">
                                    Showing {result.page.start + 1} - {result.page.start + result.page.total} of {result.page.total_records} records.
                                </div>
                            }

                            <div className="d-flex tbl-search-head">
                                <div className="my-auto">
                                    <SearchForm dataRef={sdataRef} onSearch={list} />
                                </div>
                                <div className="ml-auto my-auto">
                                    <Button type="primary" onClick={() => formRef.current.openForm()}> <img src={plus} alt='' className='mr5' height={15}/> Add</Button>
                                </div>
                            </div>

                            <If cond={result.data.length}>
                                <div className="table-responsive">
                                    <table className="table table-bordered table-md table-striped table-hover m-0">
                                        <thead className="thead-light text-uppercase table-text-vmid">
                                            <tr>
                                                <th className="w20">SN</th>
                                                <th>Category</th>
                                                <th className="w60">Code</th>
                                                <th className="w100">Item Type</th>
                                                <th className="w120">Sub Category</th>
                                                <th className="w60">Status</th>
                                                <th className="w70"></th>
                                            </tr>
                                        </thead>
                                        <tbody className="table-text-top">
                                            {result.data.map((v, i) => (
                                                <tr key={i}>
                                                    <td>{result.page.start + i + 1}.</td>
                                                    <td>{v.name}</td>
                                                    <td>{v.category_code}</td>
                                                    <td>{v.type}</td>
                                                    <td className="nowrap">
                                                        <button type="button" className="btn btn-sm btn-primary nowrap" onClick={() => openSubCatDrawer({ catId: v.id, catDtl: v })}>
                                                            Sub Categories <span className="badge badge-warning">{v.subcats?.length}</span>
                                                        </button>
                                                    </td>
                                                    <td className="nowrap">
                                                        {v.status ? (<AntdTag type="success">Active</AntdTag>) : (<AntdTag type="danger">Inactive</AntdTag>)}
                                                    </td>
                                                    <td className="text-center">
                                                        <Button.Group size="small">
                                                            <Button type="default" onClick={() => formRef.current.openForm(v)}><img src={edit} alt='' className='mr5' height={15}/></Button>
                                                            <Button type="default" onClick={() => deleteRecord(v.id)}><img src={xmark} alt='' className='mr5' height={15}/></Button>
                                                        </Button.Group>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="d-flex tbl-foot-bx">
                                    <AntdPaging
                                        onChange={list}
                                        total={result.page.total_records}
                                        current={result.page.cur_page}
                                        pageSize={sdataRef.current.ps}
                                        showSizeChanger
                                    />
                                </div>
                            </If>
                            <If cond={!result.data.length}>
                                <div className="no-rec">No record found</div>
                            </If>
                        </div>
                    </div>
                </div>
            </div>

            <AddForm
                ref={formRef}
                callback={list}
                pageno={sdataRef.current.p}
            />
            {subCat.drawerVisible &&
                <AssetSubCat {...subCat} callback={list} pageno={sdataRef.current.p} handleClose={() => setSubCat({ ...subCat, drawerVisible: false })} />
            }
        </div>
    )
}

const SearchForm = (props) => {
    let { dataRef, onSearch } = props;
    let [data, setData] = useState({ ...dataRef.current });
    const handleChange = (v, k) => {
        data[k] = v;
        setData({ ...data });
    }
    useEffect(() => {
        dataRef.current = { ...data };
    }, [data]);

    useEffect(() => {
        setData({ ...data, p: dataRef.current.p, ps: dataRef.current.ps });
    }, [dataRef.current.p, dataRef.current.ps]);

    return (
        <form onSubmit={e => e.preventDefault()} autoComplete="off" spellCheck="false">
            <div className="d-flex">
                <div>
                    <Input placeholder="Search" allowClear value={data.k} onChange={e => handleChange(e.target.value, 'k')} />
                </div>
                <div>
                    <Button type="primary" icon={<img src={ search} alt='search' height={15} />} onClick={() => onSearch()}></Button>
                </div>
            </div>
        </form>
    )
}

const AddForm = forwardRef((props, ref) => {
    let { callback, pageno } = props;
    const [showForm, setShowForm] = useState(false);
    let [data, setData] = useState({});
    const handleChange = (v, k) => {
        data[k] = v;
        setData({ ...data });
    }
    const save = () => {
        message.destroy();
        util.showLoader();
        AssetService.saveCat(data).then(({ data }) => {
            message.success(data.message || 'Saved');
            callback(data.id ? pageno : 1);
            setShowForm(false);
        }).catch(e => {
            message.error(e.message);
        }).finally(() => {
            util.hideLoader();
        })
    }

    const closeForm = () => {
        setShowForm(false);
    }

    useImperativeHandle(ref, () => ({
        openForm(dtl) {
            setData(dtl ? { ...dtl } : { type: 'Med/NonMed', status: '1' });
            setShowForm(true);
        }
    }));

    return (
        <Modal
            title={`${data.id ? 'Edit' : 'Add'} Category`}
            visible={showForm}
            okText="Save"
            onOk={save}
            onCancel={closeForm}
            destroyOnClose
            maskClosable={false}
            width={400}
        >
            <form onSubmit={e => { e.preventDefault(); save() }} autoComplete="off" spellCheck="false">
                <div className="">
                    <div className="row mingap">
                        <div className="col-md-12 form-group">
                            <label className="req">Category Name</label>
                            <Input value={data.name || ''} onChange={e => handleChange(e.target.value, 'name')} />
                        </div>
                        <div className="col-md-12 form-group">
                            <label className="req">Code</label>
                            <Input value={data.category_code || ''} onChange={e => handleChange(e.target.value, 'category_code')} />
                        </div>
                        <div className="col-md-12 form-group">
                            <label className="req">Item Type</label>
                            <div>
                                <AntdSelect
                                    options={["Med/NonMed", "Infrastructure"]}
                                    value={data.type}
                                    onChange={v => handleChange(v, 'type')}
                                />
                            </div>
                        </div>
                        <div className="col-md-12 form-group">
                            <label className="req">Status</label>
                            <div>
                                <AntdSelect
                                    options={[{ value: '1', label: "Active" }, { value: '0', label: "Inactive" }]}
                                    value={data.status}
                                    onChange={v => handleChange(v, 'status')}
                                />
                            </div>
                        </div>
                    </div>
                </div>

            </form>
        </Modal>
    )
})